<template>
  <div class="pointer" v-show="loaded">
    <div @click="goToAbout(game)" class="card pointer" style="margin-top: 40px; margin-bottom: 40px; border: 2px solid #00000000 !important; background-color: #1e252c81;">
        <div class="row no-gutters">
            <b-col md="3">
                <img @click="goToAbout(game)" :src="url" class="thumbnail" @load="onImageLoaded"/>
            </b-col>
            <b-col md="9">
                <div class="card-block px-2 padded">
                    <h4 class="card-title">{{ game.name }}</h4>
                    <p class="card-text">{{ game.summary }}</p>
                    <i class="fas fa-arrow-alt-circle-right right-bottom"></i>
                </div>
            </b-col>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'shortdetail',
  props: ['game'],
  data: () => {
    return {
      loaded: false
    }
  },
  computed: {
    url: function () {
      return this.game.cover ? this.game.cover.url.replace('thumb', 'cover_big') : 'https://thumbs.gfycat.com/GranularElementaryIncatern-size_restricted.gif'
    }
  },
  methods: {
    onImageLoaded () {
      this.loaded = true
    },
    goToAbout (game) {
      this.$router.push(
        { name: 'game-details',
          params: {
            slug: game.slug
          }
        })
    }
  }
}
</script>
<style>
.pointer {
  cursor: pointer;
  pointer-events: auto;
}
.right-bottom {
  position: absolute;
  bottom: 1px;
  right: 5px;
  padding: 10px;
  color: #8a8a8ac2;
}
.padded {
  padding: 5px;
}

.thumbnail {
  float: left;
  min-width: 50%;
}

@media (max-width: 767px) {
  .thumbnail {
    float: none;
    min-width: 100%;
  }
}
</style>
